import { ErrorMessage, Field } from 'formik'

export function FormInput({
  name,
  label,
  type = 'text',
  placeholder,
  required = false,
  className = '',
  showLabel = true,
  variant = 'default', // 'default' | 'underline'
  ...props
}) {
  const inputStyles = {
    default: `w-full min-w-0 border-2 border-foreground/20 bg-card px-4 py-3 text-base text-foreground font-serif placeholder:text-muted-foreground/60 transition-all focus:outline-none focus:border-foreground focus:bg-background`,
    underline: `w-full min-w-0 border-0 border-b-2 border-foreground/30 bg-transparent px-1 py-3 text-base text-foreground font-serif placeholder:text-muted-foreground/60 transition-all focus:outline-none focus:border-foreground`,
  }

  return (
    <div className="w-full">
      {showLabel && (
        <label
          htmlFor={name}
          className="block text-left font-sans text-xs font-medium uppercase tracking-widest text-muted-foreground mb-2"
        >
          {label}
        </label>
      )}
      <Field name={name}>
        {({ field, meta }) => (
          <>
            <input
              {...field}
              {...props}
              id={name}
              type={type}
              placeholder={placeholder}
              required={required}
              className={`${inputStyles[variant]} ${
                meta.touched && meta.error
                  ? 'border-destructive focus:border-destructive'
                  : ''
              } ${className}`}
            />
            <ErrorMessage
              name={name}
              component="div"
              className="mt-2 text-sm text-destructive font-sans"
            />
          </>
        )}
      </Field>
    </div>
  )
}
